export default "__VITE_PUBLIC_ASSET__6509c21f__"